import API from "./API";

// user login api
export const userLogin = async (fromData) => {
  const response = await API.post(`api/login/`, fromData, {
    headers: { "Content-Type": "application/json" },
  }).catch();
  return response ? response.data : {};
};
// staff creation
export const staffCreate = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/users/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const staffList = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/users/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const deleteStaff = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`api/users/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const updateStaff = async (staff_id, fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`api/users/${staff_id}`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
//branch crud

export const branchCreate = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/branches/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const branchList = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/branches/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const deleteBranch = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`api/branches/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const updateBranch = async (branch_id, fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`api/branches/${branch_id}`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
//party crud

export const partyCreate = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/parties/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const partyList = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/parties/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const deleteParty = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`api/parties/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const updateParty = async (party_id, fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`api/parties/${party_id}`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// party and branch list
export const branchpartyList = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/party-branch-list/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

//freight crud

export const freightCreate = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/freights/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const freightList = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return d.toISOString().split("T")[0]; // sirf YYYY-MM-DD return karega
  };

  try {
    const response = await API.get(`api/freights/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        page,
        party_name: filters.party_name || "",
        do_no: filters.do_no || "",
        ref_no: filters.ref_no || "",
        truck_no: filters.truck_no || "",
        loading_date: formatDate(filters.loading_date),
        from_to: filters.from_to || "",
        freight_not_rec: filters.freight_not_rec || false,
      },
    });

    return response.data;
  } catch (error) {
    console.error("Failed to fetch freight list:", error);
    return { results: [], next: null };
  }
};

export const freightDelete = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`api/freights/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const updateFreight = async (freight_id, fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`api/freights/${freight_id}`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const freightComplete = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/freights/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
// due freight page crud

export const freightListforInvoiceCreation = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(
    `api/freights/invoice/creation/?page=${page}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${access}`,
      },
      params: {
        party_name: filters.party_name || "",
        do_no: filters.do_no || "",
        truck_no: filters.truck_no || "",
      },
    }
  ).catch(() => { });
  return response ? response.data : {};
};

export const dueFreightDelete = async (freight_id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(
    `api/freights/invoice/creation/${freight_id}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    }
  ).catch();
  return response ? response.data : {};
};
export const dueFreightUpdate = async (freight_id, formdata) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(
    `api/freights/invoice/creation/${freight_id}`,
    formdata,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    }
  ).catch();
  return response ? response.data : {};
};

export const getFreightsByPartyIdApi = async (party_id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/party/freights/${party_id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

//issue crud
export const issueCreate = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/issues/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const issueList = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/issues/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const issueSolveapi = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/issues/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const issueListbyVehilce = async (vehicle_id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/freight/issues/${vehicle_id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// dropdown crud

//history crud
export const todayHistoryList = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/history/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
//bill crud
export const getFreightsByBilPartyIdApi = async (party_id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/party/freights/bill/${party_id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
// freight invoice crud
export const freightInvoiceCreate = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/freight/invoice/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const freightInvoiceList = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/freight/invoice/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
//freight pay crud

export const freightPayCreate = async (id, fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`api/freight-payments/${id}`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const freightPayList = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/freight-payments/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
    params: {
      page,
      freight_id: filters.freight_id || "",
      pay_date: filters.pay_date || "",
    },
  }).catch();
  return response ? response.data : {};
};


export const freightPayListReports = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get("api/all/freights/payment/", {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${access}`,
      },
      params: {
        page,
        freightId: filters.freightId || "",
        created_at: filters.created_at || "",
      },
    });
    return response.data; // Expecting { count, next, previous, results }
  } catch (error) {
    console.error("Error fetching billings:", error);
    return {};
  }
};


export const paySettlement = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/freight-payments/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const freightPayDelete = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`api/freight-payments/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const freightPayUpdate = async (freight_pay_id, fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(
    `api/freight-payments/${freight_pay_id}`,
    fromData,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    }
  ).catch();
  return response ? response.data : {};
};

//freight pay crud

export const billCreate = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/billings/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const billList = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get(`api/billings/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        page,
        branch: filters.branch || "",
        billId: filters.billId || "",
        freightId: filters.freightId || "",
        party: filters.party || "",
      },
    });
    return response.data; // expect { results: [], next: ... } structure
  } catch (error) {
    console.error("Error fetching bills:", error);
    return { results: [], next: null };
  }
};

export const billSettlement = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/billings/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const billDelete = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`api/billings/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const billUpdate = async (bill_id, fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`api/billings/${bill_id}`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const billFreightList = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/bill/freight/list/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// get bill by party id
export const getBillsByPartyApi = async (party_id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/payments/${party_id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// party payment crud
export const paymentList = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/payments/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const paymentsCreate = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/payments/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// party payment crud
export const dashboardApi = async (page = 1, search = "") => {
  console.log("SEARCH PARAM =", search);
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(
    `api/dashboard/?page=${page}&page_size=5&search=${search}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    }
  ).catch();

  return response ? response.data : {};
};
// truck freight
export const truckfreightList = async (truck_no) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/truck/freight/${truck_no}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

// 1. All Freights

export const allfreightList = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const formatDate = (date) => {
    if (!date) return "";
    const d = new Date(date);
    return d.toISOString().split("T")[0]; // sirf YYYY-MM-DD return karega
  };
  try {
    const response = await API.get("freights/all/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        page,
        party_name: filters.party_name || "",
        do_no: filters.do_no || "",
        ref_no: filters.ref_no || "",
        truck_no: filters.truck_no || "",
        loading_date: formatDate(filters.loading_date),
        from_to: filters.from_to || "",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to fetch freight list", error);
    return { results: [], next: null };
  }
};

// 2. Bill Pending Freights
export const billPendingFreights = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  // Remove undefined/null/empty values
  const cleanFilters = {};
  Object.keys(filters).forEach((key) => {
    if (filters[key] !== undefined && filters[key] !== null && filters[key] !== "") {
      cleanFilters[key] = filters[key];
    }
  });

  const params = new URLSearchParams({ page, ...cleanFilters });

  const response = await API.get(
    `freights/bill-pending/?${params.toString()}`,
    {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${access}`,
      },
    }
  ).catch(() => null);

  return response ? response.data : { results: [], next: null };
};



// 3. Completed Freights

export const completedFreights = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get(`freights/completed/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        page,
        party_name: filters.party_name || "",
        tp_no: filters.tp_no || "",
        truck_no: filters.truck_no || "",
      },
    });
    return response.data;
  } catch (error) {
    return { results: [], next: null };
  }
};

// 4. Freights by Party ID


export const freightsByParty = async (party_id, page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get(`freights/party/${party_id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
    params: {
      page,
      tp_no: filters.tp_no || "",
      truck_no: filters.truck_no || "",
    },
  }).catch(() => null);

  return response ? response.data : { results: [], next: null };
};
// 5. Freights by Branch ID


export const freightsByBranch = async (branch_id, page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`freights/branch/${branch_id}/?page=${page}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
    params: {
      page,
      tp_no: filters.tp_no || "",
      truck_no: filters.truck_no || "",
    },
  }).catch(() => null);
  return response ? response.data : { results: [], next: null };
};

// 6. Unique Truck Numbers
export const uniqueTruckNumbers = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`freights/truck-numbers/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch(() => { });
  return response ? response.data : {};
};

// 7. Freights by Truck Number

export const freightsByTruck = async (truck_no, page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get(
      `freights/truck/${truck_no}/?page=${page}`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access}`,
        },
        params: {
          tp_no: filters.tp_no || "",
        }
      }
    );

    if (!response?.data) return [];

    // If paginated response
    if (Array.isArray(response.data.results)) {
      return response.data.results;
    }

    // If non-paginated array
    if (Array.isArray(response.data)) {
      return response.data;
    }

    return [];
  } catch (error) {
    console.error("Error fetching freightsByTruck:", error);
    return [];
  }
};

//1. all bills

export const getAllBillings = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get("billing-report/", {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        page,
        branch: filters.branch || "",
        billId: filters.billId || "",
        freightId: filters.freightId || "",
        party: filters.party || "",
      },
    });
    return response.data; // Expecting { count, next, previous, results }
  } catch (error) {
    console.error("Error fetching billings:", error);
    return {};
  }
};

// 2. complete bills

export const getCompleteBillings = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get(
      "billing-report/complete/",
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access}`,
        },
        params: {
          page,
          branch: filters.branch || "",
          billId: filters.billId || "",
          freightId: filters.freightId || "",
          party: filters.party || "",
        },
      });
    return response.data; // Expecting { count, next, previous, results }
  } catch (error) {
    console.error("Error fetching billings:", error);
    return {};
  }
};

// 3. pending bills

export const getPendingBillings = async (page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get("billing-report/pending/", {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${access}`,
      },
      params: {
        page,
        branch: filters.branch || "",
        billId: filters.billId || "",
        freightId: filters.freightId || "",
        party: filters.party || "",
      },
    });
    return response.data; // Expecting { count, next, previous, results }
  } catch (error) {
    console.error("Error fetching billings:", error);
    return {};
  }

};

// 4. party bills

export const getBillingsByParty = async (partyId, page = 1, filters = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  try {
    const response = await API.get(
      `billing-report/party/${partyId}/`,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${access}`,
        },
        params: {
          page,
          branch: filters.branch || "",
          billId: filters.billId || "",
        },
      });
    return response.data; // Expecting { count, next, previous, results }
  } catch (error) {
    console.error("Error fetching billings:", error);
    return {};
  }
};

// 5. branch bills

export const getBillingsByBranch = async (branchId) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`billing-report/branch/${branchId}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch(() => { });
  return response ? response.data : {};
};

//    recycle bin

export const staffRestore = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/recycle-bin/staff/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const staffRecycle = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/recycle-bin/staff/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const branchRestore = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/recycle-bin/branch/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const branchRecycle = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/recycle-bin/branch/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const partyRestore = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/recycle-bin/party/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const partyRecycle = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/recycle-bin/party/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const freightRestore = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/recycle-bin/freight/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const freightRecycle = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/recycle-bin/freight/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const billRestore = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/recycle-bin/bill/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const billRecycle = async () => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/recycle-bin/bill/`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const freightPrint = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(`api/freight/print/?freight_id=${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const paymentPrint = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.get(
    `api/payment/print/?freight_payment_id=${id}`,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
    }
  ).catch();
  return response ? response.data : {};
};

// Fetch Freight data with optional date filter
export const fetchFreightFilter = async (startDate = "", endDate = "") => {
  const access = JSON.parse(localStorage.getItem("access"));
  let url = "api/freight-date-filter/"; // ✅ updated endpoint

  if (startDate && endDate) {
    url += `?start_date=${startDate}&end_date=${endDate}`;
  }

  const response = await API.get(url, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch((err) => {
    console.error("Error fetching freights:", err);
  });

  return response ? response.data : [];
};

// TDS Declaration Create
export const tdsDeclarationCreate = async (fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.post(`api/tds-declarations/`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};
export const searchTdsDeclarations = async (params = {}) => {
  const access = JSON.parse(localStorage.getItem("access"));
  console.log("Searching TDS Declarations with params:", params);
  try {
    const response = await API.get(`api/tds-declarations/`, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${access}`,
      },
      params: {
        page: params.page || 1,
        page_size: params.page_size || 50,
        truck_no: params.truck_no || "",
        truck_owner: params.truck_owner || "",
        financial_year: params.financial_year || "",
      }
    });

    return response ? response.data : {};
  } catch (error) {
    console.error("Error fetching TDS declarations:", error);
    throw error;
  }
};
export const deleteTdsDeclaration = async (id) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.delete(`api/tds-declarations/${id}`, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};


export const updateTdsDeclaration = async (tdsId, fromData) => {
  const access = JSON.parse(localStorage.getItem("access"));
  const response = await API.put(`api/tds-declarations/${tdsId}`, fromData, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();
  return response ? response.data : {};
};

export const issueAlertList = async () => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.get("api/issue-alerts/", {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${access}`,
    },
  }).catch();

  return response ? response.data : [];
};

export const uploadPaymentExcel = async (formData) => {
  const access = JSON.parse(localStorage.getItem("access"));

  const response = await API.post(
    "freight/upload-payment-excel/",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${access}`,
      },
    }
  ).catch();

  return response ? response.data : {};
};